var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 4.66667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H4.66667",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V4.66667",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 11.3334V12.6667C14 13.0203 13.8595 13.3595 13.6095 13.6095C13.3594 13.8596 13.0203 14 12.6667 14H11.3333",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66667 14H3.33333C2.97971 14 2.64057 13.8596 2.39052 13.6095C2.14048 13.3595 2 13.0203 2 12.6667V11.3334",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 5.33337H9.99999",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 8H11.3333",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 10.6666H8.66666",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export default ForwardRef;